import { Header, Sidebar } from '../../Layout';
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { getAudienceList, createAudience, deleteAudience, updateAudience, changeAudienceStatus} from '../../../../actions/masterDataActions';
import * as Yup from "yup";
import moment from 'moment';
import { Loading } from '../../../shared';

const Audience = (props) => {

    const dispatch = useDispatch()
    const [audienceId, setAudienceId] = useState()
    const [editMode, setEditMode] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    // const [editData, setEditData] = useState()
    const { audiences , loading} = useSelector(state => state.adminStore)
    const { user } = useSelector(state => state.auth)

    useEffect(() => {
        dispatch(getAudienceList())
    }, [dispatch])

    const formik = useFormik({
        initialValues: {
            id: '',
            name: '',
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Audience name is requied').max(50, "Name should be less than 50")
        }),
        onSubmit: async (value, { resetForm }) => {
            console.log(value);
            editMode ? dispatch(updateAudience(value)) : dispatch(createAudience(value))
            //console.log(editMode)
            //dispatch(updateAudience(value))
            resetForm();
            setEditMode(false);
        },
    });

    const deleteModalClose = () => {
        setDeleteModal(false)
        setAudienceId()
    }
    // const hideEditModal = () => {
    //     setEditMode(false)
    //     setAudienceId()
    // }
    const handleDeleteProfileSubmit = async () => {
        dispatch(deleteAudience(audienceId))
        setDeleteModal(false)
        setAudienceId()
    }
    const deleteModalShow = audienceId => {
        setAudienceId(audienceId)
        setDeleteModal(true)
    }
    const showEditModal = todoToEdit => {
        setEditMode(true);
        console.log(todoToEdit)
        formik.setFieldValue('name', todoToEdit.name);
        formik.setFieldValue('id', todoToEdit.id);
        // setEditData(todoToEdit);
     }

    const handleChangeStatus = (audienceStatus) => {
        const updateData ={
            id: audienceStatus.id,
            status: audienceStatus.status  ? false : true ,
        };
        console.log(updateData)
        dispatch(changeAudienceStatus(updateData))
    }
    if (loading) {
        return (
            <Loading />
        );
    }

    return (<>
        <Header />
        <Sidebar />
        <div id="main-content">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h2>Manage Audience</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right">
                        <ul className="breadcrumb">
                            {/* <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li> */}
                            <li className="breadcrumb-item active">Manage Audience</li>
                        </ul>
                        {/* <Link to="/admin/create-email-template" className="btn btn-sm btn-primary" title="">Create New</Link> */}
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <form className="form-group" onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6">
                            <label htmlFor="title" className="control-label">Add New Audience<span className='text-danger'>*</span></label>
                            <input type="text" placeholder='Enter audience name' name={'name'} id="name" className="form-control custom_input"  {...formik.getFieldProps('name')} />
                            {formik.touched.name && formik.errors.name ? (
                                <div className="text-danger pt-2">{formik.errors.name}</div>
                            ) : null}
                        </div>

                        <div className='col-lg-2 col-md-2 col-sm-2 custom_mt-4 p-0'>
                           
                            <button className='btn button' type='submit'> {editMode ? 'Update Audience' : 'Add Audience'} </button>
                        </div>
                    </div>
                   
                </form>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Created At</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                audiences?.length ? audiences?.map((audience, index) => {
                                                    return (<tr key={index}>
                                                        <td>{index+1}</td>
                                                        <td>{audience?.name}</td>
                                                        <td>{moment(audience.createdAt).format("DD/MM/YYYY")}</td>
                                                        <td>
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" id={`box-${index}`} defaultChecked={audience?.status ? true : false } onChange={()=>{handleChangeStatus(audience)}}/>
                                                                    <label className="custom-control-label" htmlFor={`box-${index}`}></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        {user.userType === 'admin'  ? (<>
                                                            <button  title='Delete User' data-toggle="modal" className='mx-2 btn btn-outline-danger' data-target="#exampleModalLong" onClick={() => deleteModalShow(audience.id)}>
                                                                <i className='fa fa-trash'></i>
                                                            </button>

                                                        </>) : ( <></>)}
                                                        <button className='btn custom-btn-outline-info' title='Edit User' onClick={() => showEditModal(audience)}><i className='fa fa-edit'></i></button>
                                                        </td>
                                                    </tr>)
  
                                                }) : <></>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <Modal show={deleteModal} onHide={deleteModalClose} >
                                <div className="modal-dialog  m-0" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title text-danger">Delete Audience From Server</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteModalClose}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Are you sure to delete?
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn custom-btn-outline-info" data-dismiss="modal" onClick={handleDeleteProfileSubmit}>Confirm</button>

                                            <button type="button" className="btn btn-outline-danger" data-dismiss="modal" onClick={deleteModalClose}>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default Audience;